const benefitsSlider = () => {

	const positionSliderControl = () => {
		const $slider = $('.benefits-slider__inner');
		const $sliderContent = $('.swiper-slide-active .benefits-slider__additional-content');
		if ($slider.length !== 0 && $sliderContent.length !== 0) {
			const sliderOffset = $slider.offset().top;
			const contentOffset = $sliderContent.offset().top;
			const controlOffset = contentOffset - sliderOffset - 40;
			$('.swiper-pagination').css('top', controlOffset);
			$('.slider-arrow').css('top', controlOffset);
			window.requestAnimationFrame(positionSliderControl);
		}
	}

	$(window).resize(() => {
		positionSliderControl();
	})

	window.requestAnimationFrame(positionSliderControl);

	positionSliderControl();

	$('.js-benefits-open').click((event) => {
		event.preventDefault();
		$('.benefits-slider').removeClass('js-benefits-closed');
		$('.benefits-slider').addClass('js-benefits-opened');
		$('.benefits-slider .benefits-slider__inner').fadeIn(300);
		$('.benefits-slider')[0].scrollIntoView({
			behavior: "smooth", 
			block: "start"
		});
	});

	$('.js-benefits-close').click((event) => {
		event.preventDefault();
		$('.benefits-slider').addClass('js-benefits-closed');
		$('.benefits-slider').removeClass('js-benefits-opened');
		$('.benefits-slider .benefits-slider__inner').fadeOut(300);
		$('.hotspot').parent().children('.text-box')[0].scrollIntoView({
			behavior: "smooth", 
			block: "start"
		});
	});
};

export default benefitsSlider;
